<template>
  <m-card314 class="product-card-313 " :image="product.thumbnail" :alt="product.name">
    <template #p-1>
      <h5 class="mt-1 mr-2 price-card-description">
        {{ product.name }}
      </h5>
    </template>
    <template #p-2>
      <div class="col-12 price-card-title pb-2 px-0">
        <template v-if="product.variation == 1" v-for="feature in productFeatureSubProduct(product)">
          <ProductCard313PriceManager class="product-card-200-price-manager-wrapper"
                                      show-trash-only-in-first-quantity="true"
                                      :product="product"
                                      :feature="feature"/>
        </template>
        <ProductCard313PriceManager show-trash-only-in-first-quantity="true"
                                    class="product-card-200-price-manager-wrapper" v-else :product="product"/>
      </div>
    </template>
    <template #p-3>
      <div class="">
        <img class="product-card-313-category-image d-inline-block shadow border" :src="category.image"
             :alt="category.name"
             v-for="category in product.category">
      </div>
    </template>
  </m-card314>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import mA from '../../../Tags/A.vue'
import mImg from '../../../Tags/Img.vue'
import {OfferProps} from "../../../Product/ProductOffer/ProductOfferProps";
import VariationProduct from "./../../SingleProductPrice3/VariationProduct.vue";
import {productFeatureName, productFeatureSubProduct} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mShoppingCartQuantityManager1 from "../../ShoppingCartQuantityManager1.vue";
import ProductCardPrice200 from "./../../ProductCardPrice200/ProductCardPrice200.vue";
import SingleProductPrice3 from "./../../SingleProductPrice3/SingleProductPrice3.vue";
import ProductCard313PriceManager from "./ProductCard313PriceManager.vue";
import mCard314 from "../../../Cards/Card314.vue";

export default {
  name: "ProductCard208",
  components: {
    ProductCard313PriceManager,
    SingleProductPrice3,
    ProductCardPrice200,
    mShoppingCartQuantityManager1,
    VariationProduct,
    mA,
    mImg,
    mCard314
  },
  props: {
    product: {},
    ...OfferProps,
  },
  data() {
    return {
      selectedVariation: null,
      selectedVariationObject: {},
    }
  },
  methods: {
    formatNumber,
    productFeatureName,
    productFeatureSubProduct,
    selectVariation(product, feature) {
      this.selectedVariation = feature.id
      this.selectedVariationObject = feature
    },
  },
}

</script>

<style scoped>

.product-card-313 :deep(img) {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.price-card-description {
  font-weight: bolder;
  font-size: 1.8rem;
}

.product-card-313-category-image {
  height: 40px !important;
  width: 40px !important;
  object-fit: contain;
  background: #fff;
  padding: 0;
  border-radius: 1rem;
  margin: 0 1px;
}

</style>